import React from 'react'
import PropTypes from 'prop-types'

// Lets import components
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'

// Let import styles for component
import './all.sass'

const TemplateWrapper = ({ children, socialNetworks, t }) => {
  return (
    <div>
      <Navbar socialNetworks={socialNetworks} t={t} />
      <div>{children}</div>
      <Footer socialNetworks={socialNetworks} t={t} />
    </div>
  )
}

export default TemplateWrapper

TemplateWrapper.propTypes = {
  socialNetworks: PropTypes.array.isRequired,
}
